import { render, staticRenderFns } from "./scoreDialog.vue?vue&type=template&id=c204e33c&scoped=true"
import script from "./scoreDialog.vue?vue&type=script&lang=js"
export * from "./scoreDialog.vue?vue&type=script&lang=js"
import style0 from "./scoreDialog.vue?vue&type=style&index=0&id=c204e33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c204e33c",
  null
  
)

export default component.exports